import { Data, DateGrouping } from '../models';
import { api } from '@/shared/services/baseApiClient';
import urljoin from 'url-join';
import { config } from '@/config/config';
import { QueryStringBuilder } from '@/shared/services/queryStringBuilder';

class FlowsReportApiService {
  private version = 'v1';

  public get(workspaceId: string, request: ReportRequest): Promise<Data> {
    const query = new QueryStringBuilder()
      .add('type', request.type)
      .add('flowId', request.flowId)
      .add('startDate', request.startDate.toISOString())
      .add('endDate', request.endDate.toISOString())
      .add('grouping', request.grouping)
      .build();

    return api.send('GET', urljoin(config().flowsHost, this.version, workspaceId, `reports`) + query);
  }
}

export interface ReportRequest {
  type: string;
  flowId?: string;
  startDate: Date;
  endDate: Date;
  grouping: DateGrouping;
}

export const flowsReportApi = new FlowsReportApiService();
